// Banner Oferta — i18n (ES / EN / SK) with Slovak countdown pluralization.

const ES = {
  labelOferta: "🔥 OFERTA DE LANZAMIENTO",
  labelVitalicio: "✅ PRECIO VITALICIO",
  descripcion: "Acceso completo a la Academia RE₿EL para siempre. Solo paga una vez.",
  subDescripcion: "Esta oferta desaparece cuando el contador llegue a cero. Después el precio subirá.",
  cta: "UNIRME AHORA POR €39.90 →",
  yaEres: "Ya eres miembro PRO",
  ofertaExpirada: "La oferta de lanzamiento ha terminado.",
  quedan: "Quedan",
  cerrar: "Cerrar",
  garantia: "🔒 Pago seguro · Sin suscripción",
  minutos: "MIN",
  segundos: "SEG",
};

const EN = {
  labelOferta: "🔥 LAUNCH OFFER",
  labelVitalicio: "✅ LIFETIME PRICE",
  descripcion: "Full access to RE₿EL Academy forever. Pay only once.",
  subDescripcion: "This offer disappears when the countdown reaches zero. Then the price will increase.",
  cta: "JOIN NOW FOR €39.90 →",
  yaEres: "You are already a PRO member",
  ofertaExpirada: "The launch offer has ended.",
  quedan: "Remaining",
  cerrar: "Close",
  garantia: "🔒 Secure payment · No subscription",
  minutos: "MIN",
  segundos: "SEC",
};

const SK = {
  labelOferta: "🔥 PONUKA PRI SPUSTENÍ",
  labelVitalicio: "✅ DOŽIVOTNÁ CENA",
  descripcion: "Plný prístup k Akadémii RE₿EL navždy. Zaplaťte len raz.",
  subDescripcion: "Táto ponuka zmizne, keď odpočítavanie dosiahne nulu. Potom cena vzrastie.",
  cta: "PRIDAŤ SA TERAZ ZA €39.90 →",
  yaEres: "Ste už PRO člen",
  ofertaExpirada: "Ponuka pri spustení sa skončila.",
  quedan: "Zostáva",
  cerrar: "Zavrieť",
  garantia: "🔒 Bezpečná platba · Bez predplatného",
  minutos: "MIN",
  segundos: "SEK",
};

const DE = {
  labelOferta: "🔥 LAUNCH-ANGEBOT",
  labelVitalicio: "✅ LIFETIME-PREIS",
  descripcion: "Vollständiger Zugang zur RE₿EL Academy für immer. Nur einmal zahlen.",
  subDescripcion: "Dieses Angebot verschwindet, wenn der Countdown null erreicht. Danach steigt der Preis.",
  cta: "JETZT FÜR €39.90 BEITRETEN →",
  yaEres: "Du bist bereits PRO-Mitglied",
  ofertaExpirada: "Das Launch-Angebot ist beendet.",
  quedan: "Noch",
  cerrar: "Schließen",
  garantia: "🔒 Sichere Zahlung · Kein Abo",
  minutos: "MIN",
  segundos: "SEK",
};

const ZH_CN = {
  labelOferta: "🔥 限时发布优惠",
  labelVitalicio: "✅ 终身价格",
  descripcion: "永久获得RE₿EL学院的完整访问权限。仅需支付一次。",
  subDescripcion: "倒计时归零后，此优惠将消失。之后价格将上涨。",
  cta: "立即加入，仅需€39.90 →",
  yaEres: "您已是PRO会员",
  ofertaExpirada: "发布优惠已结束。",
  quedan: "剩余",
  cerrar: "关闭",
  garantia: "🔒 安全支付 · 无订阅",
  minutos: "分钟",
  segundos: "秒",
};

const ALL = { es: ES, en: EN, sk: SK, de: DE, "zh-CN": ZH_CN };

export const getBannerOfertaI18n = (lang) => ALL[lang] || ALL.es;

// ── Pluralization helpers ──────────────────────────────────────────
// Slovak follows the 1 / 2-4 / 5+ rule. Spanish has only sing/plural for days.
export const labelDias = (n, lang) => {
  if (lang === "en") return n === 1 ? "DAY" : "DAYS";
  if (lang === "sk") {
    if (n === 1) return "DEŇ";
    if (n >= 2 && n <= 4) return "DNI";
    return "DNÍ";
  }
  return n === 1 ? "DÍA" : "DÍAS";
};

export const labelHoras = (n, lang) => {
  if (lang === "en") return "HOURS";
  if (lang === "sk") {
    if (n === 1) return "HODINA";
    if (n >= 2 && n <= 4) return "HODINY";
    return "HODÍN";
  }
  return "HORAS";
};
